<template>
    <AdmPanel :loading="loader[LISTED_PUNISHMENT+'fetch']">
        <h2 slot="header_title">{{isAudit?"上市公司行政处罚":"行政处罚"}}</h2>
        <div class="adm-buttons" slot="header_buttons">
          <iv-button
            v-if="isAudit"
            type="primary"
            ghost
            icon="md-flash"
            @click="reviewModal.shown=true">批量审核</iv-button>
          <iv-button
            :loading="loader[LISTED_PUNISHMENT+'export']"
            type="primary"
            icon="md-download"
            ghost
            v-rbac-allow="['listedPunishment','export']"
            @click="exportExcel()">导出</iv-button>
        </div>
        <FilterBar
            slot="tools"
            :value="conditions"
            :condition="options.filter_rules"
            :builder="builder"
            @search="changeQuery">
            <iv-form-item>
              <iv-datePicker type="daterange" placeholder="请选择爬取时间" v-model="conditions.timeScope" format="yyyy-MM-dd"
                style="width: 200px;"></iv-datePicker>
            </iv-form-item>
            <iv-form-item v-if="isAudit">
              <iv-select clearable placeholder="审核状态" v-model="conditions.audit" style="width:100px">
                <iv-option v-for="(item,i) in options.audit" :value="item.id" :key="i">
                  {{ item.name }}</iv-option>
              </iv-select>
            </iv-form-item>
            <iv-form-item>
              <iv-button
                  type="info"
                  :disabled="loader[LISTED_PUNISHMENT+'fetch']"
                  @click="changeQuery()">
                  <iv-icon type="md-search" size="14" style="vertical-align:text-bottom" /> 搜索
              </iv-button>
            </iv-form-item>
        </FilterBar>
        <div style="margin-bottom: 12px">
            <span style="width:6em;text-align: right;display: inline-block;">一级指标：</span>
            <iv-select
                v-model="conditions.firstTargetNum"
                filterable
                clearable
                style="width:120px"
                placeholder="一级指标"
                @on-change="changeQuery({ ...conditions,offset:0 });conditions.secondTargetNum = '';conditions.thirdTargetNum = ''"
            >
                <iv-option v-for="(item, index) in options.firstTargets" :value="item.id" :key="item.id">{{ item.name }}</iv-option>
            </iv-select>
        </div>
        <div style="margin-bottom: 12px">
            <span style="width:6em;text-align: right;display: inline-block;">二级指标：</span>
            <iv-select
                v-model="conditions.secondTargetNum"
                filterable
                clearable
                style="width:400px;"
                placeholder="二级指标"
                @on-change="changeQuery({ ...conditions,offset:0 });conditions.thirdTargetNum = ''"
            >
                <iv-option v-for="(item,key) in options.secondTargets" :value="item.id" :key="item.id + key">{{ item.name }}</iv-option>
            </iv-select>
        </div>
        <div style="margin-bottom: 12px">
            <span style="width:6em;text-align: right;display: inline-block;">三级指标：</span>
            <iv-select
                v-model="conditions.thirdTargetNum"
                filterable
                clearable
                style="width:400px;"
                placeholder="三级指标"
                @on-change="changeQuery({ ...conditions,offset:0 })"
            >
                <iv-option v-for="(item,key) in options.thirdTargets" :value="item.id" :key="item.id + key">{{ item.name }}</iv-option>
            </iv-select>
        </div>
            <div>
              <p v-if="list.data.length <= 0 " class="text-center">
                  <EmptyData>
                      <div class="nextPage" slot="emptyBtn">
                          <iv-button @click="changeQuery()">重新获取</iv-button>
                      </div>
                  </EmptyData>
              </p>
              <template v-else-if="isAudit">
                <iv-card class="adm-checklist" dis-hover :bordered="false">
                  <iv-checkbox :indeterminate="indeterminate" :value="checkAll" @click.prevent.native="handleCheckAll">
                    全选
                  </iv-checkbox>
                  <span>已选 {{ selection.list.length }} 项目，所选项将</span>
                  <span class="adm-buttons">
                    <iv-button type="primary" :disabled="selection.list.length<=0" size="small"
                      @click="reviewList('pass')">通过</iv-button>
                    <iv-button type="primary" ghost size="small" v-if="selection.list.length<=0"
                      :disabled="selection.list.length<=0">不通过</iv-button>
                    <iv-poptip ref="selectionPoptipTop" v-model="selection.shown" v-else>
                      <iv-button type="primary" ghost size="small" :disabled="selection.list.length<=0">不通过</iv-button>
                      <div slot="content" style="text-align: left;">
                        <iv-form label-position="top">
                          <iv-form-item label="审核批注（选填）">
                            <iv-input type="textarea" v-model="selection.comment" />
                          </iv-form-item>
                          <div class="adm-buttons" style="text-align:right">
                            <iv-button type="text" size="small" @click="closeSelectionPoptip('selectionPoptipTop')">
                              取消
                            </iv-button>
                            <iv-button type="primary" size="small"
                              @click="reviewList('fail');closeSelectionPoptip('selectionPoptipTop')">
                              发送
                            </iv-button>
                          </div>
                        </iv-form>
                      </div>
                    </iv-poptip>
                  </span>
                </iv-card>
                <iv-checkbox-group class="adm-list ui-wrapper" v-model="selection.checkboxData" @on-change="checkboxData">
                    <ListedPunishmentItem
                      v-for="item in list.data"
                      :key="item.id"
                      :value="item"
                      type="audit"
                      @Detail="onDetail(item)"
                      @Edit="Edit(item)"
                      @qySnapshot="onqySnapshot(item)"
                    >
                      <iv-checkbox slot="checkbox" :label="item.id"><span></span></iv-checkbox>
                      <span slot="buttons">
                        <iv-button type="primary" size="small" @click="review('pass',item)">通过</iv-button>
                        <iv-poptip :ref="'selectionPoptipDown' + item.id" v-model='item.shown'>
                          <iv-button type="primary" ghost size="small" style="margin-left:10px">不通过</iv-button>
                          <div slot="content" style="text-align: left;">
                            <iv-form label-position="top">
                              <iv-form-item label="审核批注（选填）">
                                <iv-input type="textarea" v-model="item.comment" />
                              </iv-form-item>
                              <div class="adm-buttons" style="text-align:right">
                                <iv-button type="text" size="small"
                                  @click="closeSelectionPoptip('selectionPoptipDown' + item.id )">
                                  取消
                                </iv-button>
                                <iv-button type="primary" size="small"
                                  @click="review('fail',item);closeSelectionPoptip('selectionPoptipDown' + item.id)">
                                  发送
                                </iv-button>
                              </div>
                            </iv-form>
                          </div>
                        </iv-poptip>
                      </span>
                    </ListedPunishmentItem>
                </iv-checkbox-group>
                <iv-card class="adm-checklist" dis-hover :bordered="false">
                  <iv-checkbox :indeterminate="indeterminate" :value="checkAll" @click.prevent.native="handleCheckAll">
                    全选</iv-checkbox>
                  <span>已选 {{ selection.list.length }} 项目，所选项将</span>
                  <span class="adm-buttons">
                    <iv-button type="primary" :disabled="selection.list.length<=0" size="small"
                      @click="reviewList('pass')">通过</iv-button>
                    <iv-button type="primary" ghost size="small" v-if="selection.list.length<=0"
                      :disabled="selection.list.length<=0">不通过</iv-button>
                    <iv-poptip ref="selectionPoptipDown" v-model="selection.shonw2" v-else>
                      <iv-button type="primary" ghost size="small" :disabled="selection.list.length<=0">不通过</iv-button>
                      <div slot="content" style="text-align: left;">
                        <iv-form label-position="top">
                          <iv-form-item label="审核批注（选填）">
                            <iv-input type="textarea" v-model="selection.comment" />
                          </iv-form-item>
                          <div class="adm-buttons" style="text-align:right">
                            <iv-button type="text" size="small" @click="closeSelectionPoptip('selectionPoptipDown')">
                              取消
                            </iv-button>
                            <iv-button type="primary" size="small"
                              @click="reviewList('fail');closeSelectionPoptip('selectionPoptipDown')">
                              发送
                            </iv-button>
                          </div>
                        </iv-form>
                      </div>
                    </iv-poptip>
                  </span>
                </iv-card>
              </template>
              <div v-else class="adm-list ui-wrapper">
                  <ListedPunishmentItem
                    v-for="item in list.data"
                    :key="item.id"
                    :value="item"
                    @Detail="onDetail(item)"
                    @title="changeTitle"
                    @qySnapshot="onqySnapshot(item)"
                  >
                      <div>
                          <div style="margin-bottom: 10px;">
                            <iv-button v-rbac-allow="['listedPunishment','edit']" size='small' type="primary"
                              @click="Edit(item)">编辑</iv-button>
                          </div>
                          <div>
                          <iv-button v-rbac-allow="['listedPunishment','delete']" size='small' @click="Detele(item)">删除
                          </iv-button>
                          </div>
                      </div>
                  </ListedPunishmentItem>
              </div>
              <template v-if="list.last_page > 1">
                  <div slot="footer" class="pull-right" style="margin-top: 1em">
                      <iv-page
                              @on-change="pageChanged"
                              :current="list.current_page"
                              :page-size="10"
                              show-elevator
                              show-total
                              :total="list.total">
                      </iv-page>
                  </div>
              </template>
            </div>
            <EditListedPunishmentModal
                v-model="PunishmentModal.data"
                :shown="PunishmentModal.shown"
                :title="PunishmentModal.title"
                :type="PunishmentModal.type"
                @refresh="refresh"
                @shown-changed="PunishmentModal.shown=$event">
            </EditListedPunishmentModal>

            <!-- 批量审核 -->
            <iv-modal :mask-closable="false" title="批量审核" width="450" :closable="false" v-model="reviewModal.shown"
              @on-cancel="reviewModal.shown = false">
              <iv-form :model="reviewModal.formValidate" ref="reviewModalForm" :label-width="100" label-position="left" inline>
                <iv-form-item label="爬取时间" prop="timeScope">
                   <iv-datePicker type="daterange" placeholder="请选择时间段" v-model="reviewModal.formValidate.timeScope"
                     format="yyyy-MM-dd" style="width: 200px;margin-right:20px;"></iv-datePicker>
                </iv-form-item>
              </iv-form>
              <div slot="footer">
                <span class="pull-left" style="line-height: 40px;">备注：新审核数据，需等待1-2分钟生效</span>
                <iv-button type="primary" :disabled="!reviewModal.formValidate.timeScope[0]" @click="reviewTimeScope()">通过</iv-button>
                <iv-button type="default" @click="reviewModal.shown = false">关闭</iv-button>
              </div>
            </iv-modal>
            <router-view />
    </AdmPanel>
</template>

<script>
import ListedPunishmentModel  from '@/models/ListedPunishmentModel';
import CompanyModel    from '@/models/CompanyModel'
import IndustryModel from '@/models/IndustryModel'
import AuditModel from '@/models/AuditModel'
import ListedTargetModel from "@/models/ListedTargetModel";
import ModelMixin    from '@/mixins/Model.mixin';
import LoaderMixin   from '@/mixins/Loader.mixin';
import contact       from '@/utils/contact';
import {conditioner, defaultVal, getWeekRange, List} from '@/utils/';
import { downloadByUrl } from "@/utils/download";
import FilterBar from "@/components/FilterBar_x2.1";
import ListedPunishmentItem   from '@/components/ListedPunishmentItem'
import EmptyData     from '@/components/EmptyData'
import EditListedPunishmentModal     from '@/components/EditListedPunishmentModal'
import CompanySelect from "@/components/CompanySelect"
import Fecha         from '@/utils/type/Fecha'

import { audit, esg_ordering as ordering } from "@/configs/options.conf"

const LISTED_PUNISHMENT = ListedPunishmentModel.ModelName; // remove '$'
const ModelName = LISTED_PUNISHMENT;
const ADUIT = AuditModel.ModelName
const COMPANY = CompanyModel.ModelName;
const INDUSTRY = IndustryModel.ModelName
const LISTED_TARGET = ListedTargetModel.ModelName

const options = {
  year:[],
  industry:[],
  companys: [],
  scoreTag:[
      { id: "0", title: "未评分" },
      { id: "1", title: "已评分" },
  ],
  audit,
  ordering,
}

const _conditioner = conditioner(
  {
      limit            : {type: Number, default: 10},
      offset           : {type: Number, default: 0},
      id               : {type: String, default: ""},
      industryId       : {type: Number, default: ""},
      scoreTag         : {type: String, default: ""},
      punishmentNumber : {type: String, default: ""},
      punishContent    : {type: String, default: ""},
      audit           : { type: Number, default: "" },
      timeScope        : {type: val=> val.length <= 0 || val.every(item=>!item) ? '' : JSON.stringify(val.map(date=>Fecha.format(date,'YYYY-MM-DD'))) , default: ""},
      stockCode : {type: val=>val.join(''), default: ""},
  },
  {
      limit      : {type: Number, default: 10},
      offset     : {type: Number, default: 0},
      id         : {type: String, default: ""},
      industryId : {type: Number, default: ""},
      scoreTag   : {type: String, default: ""},
      punishmentNumber  : {type: String, default: ""},
      punishContent     : {type: String, default: ""},
      audit           : {type: String, default: "" },
      stockCode : {type: val=>[val], default:[]},
      timeScope  : {type: val=> !val ? [] : JSON.parse(val).map(date=>Fecha.parse(date,'YYYY-MM-DD')), default: []},
  }
)
const filter_rules = [
  {name: 'industryId', type: "Select", options: [], title: '行业', default: "", placeholder: "行业", clearable:true, style: { width: "150px" }},
  {
    name: 'stockCode',
    type: 'CompanySelect',
    options: [],
    title: '公司',
    default: [],
    placeholder: '公司',
    clearable: true,
    filterable: true,
    style: { width: '200px' },
  },
  {name: 'id', type: "Input", title: '编号', default: "", placeholder: "编号", style: { width: "150px" }},
  // {name: 'punishmentNumber', type: "Input", title: '处罚号', default: "", placeholder: "处罚号", style: { width: "150px" }},
  {name: 'title', type: "Input", title: '标题', default: "", placeholder: "", style: { width: "150px" }},
  {name: 'punishContent', type: "Input", title: '处罚内容', default: "", placeholder: "", style: { width: "150px" }},
  {name: 'scoreTag', type: "Select", options: options.scoreTag, title: '评分状态',clearable:true, default: "", placeholder: "评分状态", style: { width: "90px" }},
  {name: 'audit', type: "Select", options: options.audit, title: '审核状态',clearable:true, default: "", placeholder: "审核状态", style: { width: "90px" }},
  {name: 'ordering', type: "Select", options: options.ordering, title: '排序方式',clearable:true, default: "", placeholder: "排序方式", style: { width: "120px" }},
]


export default {
        name: "punishment",
        mixins:[
            LoaderMixin(LISTED_PUNISHMENT+'fetch',LISTED_PUNISHMENT+'export',INDUSTRY,ADUIT),
            ModelMixin({
                contact,
                models:[
                    [ListedPunishmentModel, { emulateIdKey:true }],
                    CompanyModel,
                    IndustryModel,
                    AuditModel,
                    ListedTargetModel,
                ]
            })
        ],
        data() {
            return {
                conditions: {
                  ..._conditioner.default(),
                  companyInput: ""
                },
                LISTED_TARGET,
                ModelName,
                LISTED_PUNISHMENT,
                INDUSTRY,
                COMPANY,
                ADUIT,
                list: {
                    data: [],
                    last_page:0,
                    current_page:1
                },
                options: {
                    ...options,
                    filter_rules,
                },
                source:{},
                PunishmentModal:{
                    shown:false,
                    type:"read",
                    data:null
                },
                industries:[],
                 builder:{
                  /**
                   * 增加自定义工具
                   */
                  'renderCompanySelect': (vm,h,{ fieldset, values } = {})=>{ //必须加`render`前序
                    return <CompanySelect
                      { ...{
                      style: fieldset.style,
                      props: {
                        ...fieldset,
                        value: values[fieldset.name] || fieldset.default,
                      },
                      on: {
                        'change': $event=>vm.onValueChanged($event, fieldset.name), //调用FilterBar对象内部函数
                      }
                      }}
                    ></CompanySelect>
                  }
                },
                indeterminate: false,
                checkAll: false,
                CheckAllData:[],
                selection: {
                  list: [],
                  checkboxData: [],
                  comment: "",
                  shown: false,
                },
                reviewModal:{
                  shown:false,
                  formValidate: {timeScope:[]},
                }
            }
        },
        async mounted () {
            const { query, params } = this.$route
            let conditions = _conditioner.serialize({...query,...params}) //处理成支持UI的格式

            this.industries = await this.refreshIndustry()
            this.renderFilterBar("industryId", this.industries)

            // 初始条件
            this.conditions = conditions
            this.conditions.timeScope = !!this.conditions.timeScope.length ? this.conditions.timeScope : getWeekRange()

            await this.refreshfirstTarget()
            await this.refreshsecondTarget({
              firstTargetNum: this.conditions.firstTargetNum ? this.conditions.firstTargetNum : undefined
            })
            await this.refreshthirdTarget({
              firstTargetNum:this.conditions.firstTargetNum ? this.conditions.firstTargetNum : undefined,
              secondTargetNum: this.conditions.secondTargetNum ? this.conditions.secondTargetNum : undefined
            })

            const rule = this.options.filter_rules.find(i=>i.name=='stockCode')
            rule.input = this.conditions.companyInput

            await this.refresh()
            if(this.isAudit)await this.initCheckAll()
        },
        beforeRouteUpdate(to, from, next){
            this.$nextTick(async ()=>{
                const { query, params } = to
                this.conditions = {
                    ..._conditioner.default(),
                    ..._conditioner.serialize({...query,...params}) //处理成支持UI的格式
                }
                const rule = this.options.filter_rules.find(i=>i.name=='stockCode')
                rule.input = this.conditions.companyInput
                this.conditions.timeScope = !!this.conditions.timeScope.length ? this.conditions.timeScope : getWeekRange()
                if(to.path.indexOf('/logs')>-1||from.path.indexOf('/logs')>-1) return
                await this.refresh()
                if(this.isAudit)await this.initCheckAll()
            })
            next();
        },
        methods: {
            async refresh(query=this.conditions){
                this.list              = await this.$$fetch(ModelName, _conditioner.parse(query));
                this.list.current_page = _conditioner.parse(query).offset ? _conditioner.parse(query).offset / _conditioner.parse(query).limit + 1 : 1
                this.list.last_page    = this.list.total / _conditioner.parse(query).limit
            },
            renderFilterBar(fieldName, val, defaults){
                const fieldset = this.options.filter_rules.find(fieldset=>fieldset.name===fieldName)
                fieldset.options = val
            },
            async refreshIndustry(params = this.$route.params){
                let industries;
                const industry = await this.$$fetch(INDUSTRY,{ type:'listed',params })
                if(industry) industries = industry.data.map(item=>({...item, name: item.industry}))
                return this.options.industry = industries
            },
            async refreshfirstTarget(params = this.$route.params){
                const firstTarget = await this.$$active(LISTED_TARGET, 'firstTarget',{ ...params })
                if(firstTarget)  this.options.firstTargets = firstTarget.data
            },
            async refreshsecondTarget(params = this.$route.params){
                const secondTarget = await this.$$active(LISTED_TARGET, 'secondTarget',{ ...params })
                if(secondTarget)  this.options.secondTargets = secondTarget.data
            },
            async refreshthirdTarget(params = this.$route.params){
                const thirdTarget = await this.$$active(LISTED_TARGET, 'thirdTarget',{ ...params })
                if(thirdTarget)  this.options.thirdTargets = thirdTarget.data
            },
            changeQuery(query=this.conditions, params = this.$route.params) {
                this.$router.push({
                    name  : this.$route.name,
                    query: {..._conditioner.parse(query), offset:0},
                    params: params
                });
            },
            pageChanged(page){
                this.$router.push({ name: this.$route.name, query: { ..._conditioner.parse(this.conditions), offset: ( page - 1
                ) * _conditioner.parse(this.conditions).limit}, params: this.$route.params });
            },
            onDetail(item){
              this.PunishmentModal.type="read"
              this.PunishmentModal.title="处罚详情"
              this.PunishmentModal.shown=true
              this.PunishmentModal.data = item
            },
            Edit(item){
              this.PunishmentModal.type="edit"
              this.PunishmentModal.title="修改处罚"
              this.PunishmentModal.shown=true
              this.PunishmentModal.data = item
            },
            async Detele(item){
              const res = await this.$$del(ModelName, item.id);
              console.log(res)
              if (res.code == 200) {
                this.$$success("删除成功");
                this.refresh()
              } else {
                this.$$error("删除失败", res.msg);
              }
            },
            checkboxData(){
                this.selection.list = []
                this.selection.checkboxData.map(item=> this.selection.list.push((this.list.data.filter(i=>i.id==item))[0]))
                this.checkAllGroupChange(this.selection.list)
            },
            checkAllGroupChange (data) {
                if (data.length === this.list.data.length) {
                    this.indeterminate = false;
                    this.checkAll = true;
                } else if (data.length > 0) {
                    this.indeterminate = true;
                    this.checkAll = false;
                } else {
                    this.indeterminate = false;
                    this.checkAll = false;
                }
            },
            initCheckAll(){
                this.indeterminate = false,
                this.list.data.map(item=>{this.CheckAllData.push(item.id)})
            },
            handleCheckAll () {
                if (this.indeterminate) {
                    this.checkAll = false;
                } else {
                    this.checkAll = !this.checkAll;
                }
                this.indeterminate = false;
                if (this.checkAll) {
                    this.selection.checkboxData = this.CheckAllData
                    this.selection.list = this.list.data
                } else {
                    this.selection.checkboxData = [];
                    this.selection.list = [];
                }
            },
            async review(action_name, item){
                const { id,comment } = item
                const target = { idList:[id], audit:0, comment }
                switch(action_name){
                    case 'pass':
                        target.audit = 3
                        break;
                    case 'fail':
                        target.audit = 2
                        break;
                }
                try{
                    this.$$loading(ADUIT);
                    await this.$$active(ADUIT, 'batchlistedPunishment', target)
                    this.$$loaded(ADUIT);
                }catch(e){
                    this.$$error(e)
                }
                this.refresh()
            },
            async reviewList(action_name, comment=this.selection.comment ,selection=this.selection.list){
              const audit = ['','','fail','pass'].indexOf(action_name)
              const items = selection.filter(item=>item.audit!=audit).map(item=>({ ...item, comment, audit }))
              this.selection.comment = ""
              try {
                this.$$loading(ADUIT);
                await this.$$active(ADUIT, "batchlistedPunishment", { comment, audit, idList:items.map(item=>item.id)});
                this.$$loaded(ADUIT);
              } catch (e) {
                this.$$error(e);
              }
              this.refresh();
            },
            async reviewTimeScope(){
              try {
                this.$$loading(ADUIT);
                let time = this.reviewModal.formValidate.timeScope.map(date=>Fecha.format(date,'YYYY-MM-DD'))
                const res = await this.$$active(ADUIT, "batchlistedPunishment", { comment:"", audit:3, timeScope:time });
                if (res.data.code == 202) {
                  this.$$success("审核成功");
                  this.reviewModal.shown = false
                  this.reviewModal.formValidate.timeScope = ""
                  this.refresh()
                } else {
                  this.$$error("审核失败", res.msg);
                }
                this.$$loaded(ADUIT);
              } catch (e) {
                this.$$error(e);
              }
            },
            closeSelectionPoptip(ref){
              this.$refs[ref].visible = false
            },
            async exportExcel(query = this.conditions) {
              // TODO:
              console.log("exportExcel...", this.conditions)
              const res = await this.$$active(ModelName, 'Export', {..._conditioner.parse(query) })
              if(!res.data.url) {
                this.$$info('后台未返回url，请重试')
                return
              }
              // 下载链接
              downloadByUrl(res.data.url)
            },
            async changeTitle(params){
                const result = await this.$$active(ModelName, 'title', {id : params.id, title: params.title})
                if(result instanceof Error) return;
                const item = this.list.data.filter(tag=>tag.id == params.id)
                item[0].title = params.title
            },
            async onqySnapshot(item){
                const result = await this.$$active(ModelName, 'qySnapshot', {id : item.id})
                if(result instanceof Error) return;
                window.open(result.data.url, '__brank')
            }
        },
        computed:{
          isAudit(){
            return this.$route.matched.some(item=>item.name=='audit')
          }
        },
        components:{
            FilterBar,
            ListedPunishmentItem,
            EmptyData,
            EditListedPunishmentModal,
            CompanySelect
        }
    }
</script>

<style lang="scss" scoped>
    .filter-wraper {
      margin-bottom: 20px;
    }
    .adm-panel__tools{
        margin-bottom: -50px;
    }
    .nextPage{
        margin: 15px 0;
        display: flex;
        justify-content: center;
        text-align: center;
        button{
            width: 200px;
        }
    }
</style>
